import { render, staticRenderFns } from "./Sponsor.vue?vue&type=template&id=67c3ba52&scoped=true&"
import script from "./Sponsor.vue?vue&type=script&lang=js&"
export * from "./Sponsor.vue?vue&type=script&lang=js&"
import style0 from "./Sponsor.vue?vue&type=style&index=0&id=67c3ba52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c3ba52",
  null
  
)

export default component.exports